/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chat_Tool_Detail_DeniedInputs */

const es_chat_tool_detail_denied = /** @type {(inputs: Chat_Tool_Detail_DeniedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Denegado`)
};

const en_chat_tool_detail_denied = /** @type {(inputs: Chat_Tool_Detail_DeniedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Denied`)
};

/**
* | output |
* | --- |
* | "Denied" |
*
* @param {Chat_Tool_Detail_DeniedInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const chat_tool_detail_denied = /** @type {((inputs?: Chat_Tool_Detail_DeniedInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Tool_Detail_DeniedInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_chat_tool_detail_denied(inputs)
	return en_chat_tool_detail_denied(inputs)
});
export { chat_tool_detail_denied as "chat.tool_detail.denied" }